/* Human-authored Upcart interface labels. Product names, review text, discount
   codes and prices are deliberately untouched. */
(() => {
  const locale = document.currentScript?.dataset.locale;
  const locales = ['ca', 'en', 'fr', 'de', 'it'];
  const index = locales.indexOf(locale);
  if (index < 0) return;

  const entries = [
    ['Fabricado en España', 'Fabricat a Espanya', 'Made in Spain', 'Fabriqué en Espagne', 'Hergestellt in Spanien', 'Prodotto in Spagna'],
    ['Devoluciones hasta 30 días', 'Devolucions fins a 30 dies', 'Returns within 30 days', 'Retours sous 30 jours', 'Rückgabe innerhalb von 30 Tagen', 'Resi entro 30 giorni'],
    ['Recíbelo en 3-5 días', 'Rep-lo en 3-5 dies', 'Receive it in 3–5 days', 'Recevez-le sous 3 à 5 jours', 'Lieferung in 3–5 Tagen', 'Ricevilo in 3–5 giorni'],
    ['¡Tienes envío gratis! 🎉', 'Ja tens enviament gratuït! 🎉', 'You have free shipping! 🎉', 'La livraison est offerte ! 🎉', 'Dein Versand ist kostenlos! 🎉', 'Hai la spedizione gratuita! 🎉'],
    ['Envío Gratis', 'Enviament gratuït', 'Free shipping', 'Livraison offerte', 'Kostenloser Versand', 'Spedizione gratuita'],
    ['Regalo Monedero', 'Moneder de regal', 'Free coin purse', 'Porte-monnaie offert', 'Gratis-Geldbörse', 'Portamonete in omaggio'],
    ['Bolso sorpresa', 'Bossa sorpresa', 'Surprise bag', 'Sac surprise', 'Überraschungstasche', 'Borsa a sorpresa'],
    ['Te puede interesar', 'Et pot interessar', 'You might also like', 'Vous aimerez aussi', 'Das könnte dir gefallen', 'Potrebbe piacerti'],
    ['Añadir', 'Afegeix', 'Add', 'Ajouter', 'Hinzufügen', 'Aggiungi'],
    ['Aplicar', 'Aplica', 'Apply', 'Appliquer', 'Anwenden', 'Applica'],
    ['Descuentos', 'Descomptes', 'Discounts', 'Réductions', 'Rabatte', 'Sconti'],
    ['Price', 'Preu', 'Price', 'Prix', 'Preis', 'Prezzo'],
    ['Original price', 'Preu original', 'Original price', "Prix d'origine", 'Ursprünglicher Preis', 'Prezzo originale'],
    ['Sale price', 'Preu rebaixat', 'Sale price', 'Prix soldé', 'Angebotspreis', 'Prezzo scontato'],
    ['Savings', 'Estalvi', 'Savings', 'Économies', 'Ersparnis', 'Risparmio'],
    ['Discount', 'Descompte', 'Discount', 'Réduction', 'Rabatt', 'Sconto'],
    ['Increase quantity', 'Augmenta la quantitat', 'Increase quantity', 'Augmenter la quantité', 'Menge erhöhen', 'Aumenta la quantità'],
    ['Decrease quantity', 'Redueix la quantitat', 'Decrease quantity', 'Diminuer la quantité', 'Menge verringern', 'Riduci la quantità'],
    ['Close cart', 'Tanca la cistella', 'Close cart', 'Fermer le panier', 'Warenkorb schließen', 'Chiudi il carrello'],
    ['Remove', 'Elimina', 'Remove', 'Supprimer', 'Entfernen', 'Rimuovi'],
    ['Product quantity', 'Quantitat del producte', 'Product quantity', 'Quantité du produit', 'Produktmenge', 'Quantità del prodotto'],
    ['Product carousel', 'Carrusel de productes', 'Product carousel', 'Carrousel de produits', 'Produktkarussell', 'Carosello prodotti'],
    ['Previous slide', 'Diapositiva anterior', 'Previous slide', 'Diapositive précédente', 'Vorherige Folie', 'Diapositiva precedente'],
    ['Next slide', 'Diapositiva següent', 'Next slide', 'Diapositive suivante', 'Nächste Folie', 'Diapositiva successiva'],
    ['Discount tag icon', 'Icona de descompte', 'Discount tag icon', 'Icône de réduction', 'Rabatt-Symbol', 'Icona sconto'],
  ];
  const dictionary = new Map(entries.map(([source, ...translations]) => [source, translations[index]]));
  const checkout = ['Pagament segur', 'Secure checkout', 'Paiement sécurisé', 'Sicher bezahlen', 'Pagamento sicuro'][index];
  const save = ['Estalvia', 'Save', 'Économisez', 'Spare', 'Risparmia'][index];
  const remove = ['Elimina', 'Remove', 'Supprimer', 'Entfernen', 'Rimuovi'][index];
  const slide = ['Diapositiva', 'Slide', 'Diapositive', 'Folie', 'Diapositiva'][index];
  const of = ['de', 'of', 'sur', 'von', 'di'][index];

  function translate(value) {
    const trimmed = value.trim();
    let translated = dictionary.get(trimmed);
    if (!translated) {
      const amount = trimmed.match(/^Pago seguro\s*•\s*(.+)$/);
      if (amount) translated = `${checkout} • ${amount[1]}`;
    }
    if (!translated) {
      const amount = trimmed.match(/^\(Ahorra\s+(.+)\)$/);
      if (amount) translated = `(${save} ${amount[1]})`;
    }
    if (!translated) {
      const product = trimmed.match(/^Remove (.+)$/);
      if (product) translated = `${remove} ${product[1]}`;
    }
    if (!translated) {
      const position = trimmed.match(/^Slide (\d+) of (\d+)$/);
      if (position) translated = `${slide} ${position[1]} ${of} ${position[2]}`;
    }
    return translated ? value.replace(trimmed, translated) : value;
  }

  function upcartRoots() {
    return [...document.querySelectorAll('.shopify-app-block')].filter(root => root.querySelector('script[src*="upcart-bundle"]'));
  }
  function localize(root) {
    const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
    const nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (const node of nodes) {
      if (node.parentElement?.closest('script, style, noscript')) continue;
      const translated = translate(node.nodeValue);
      if (translated !== node.nodeValue) node.nodeValue = translated;
    }
    for (const element of root.querySelectorAll('[aria-label], [title]')) {
      for (const attribute of ['aria-label', 'title']) {
        const value = element.getAttribute(attribute);
        if (!value) continue;
        const translated = translate(value);
        if (translated !== value) element.setAttribute(attribute, translated);
      }
    }
  }
  let scheduled = false;
  function refresh() {
    scheduled = false;
    upcartRoots().forEach(localize);
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(refresh);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule, { once: true });
  else schedule();
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
})();
